import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Edit from './Edit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/email-templates'),
      component: SettingsWrapper,
      meta: {
        permissions: ['administrator'],
      },
      children: [
        {
          path: '',
          redirect: to => ({ name: 'email_templates_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'email_templates_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: ':templateId/edit',
          name: 'email_templates_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: Edit,
        },
      ],
    },
  ],
};
